export default {
	props: {
		type: { type: String, required: true },
	},

	data: () => ({
		typeStrings: { author: 'autor', reviewer: 'revisor' }
	}),

	computed: {
		typeStr() {
			return this.typeStrings[this.type]
		},
		creatorAlreadyExistsError() {
			return `Já existe um ${this.typeStr} com esse nome`
		},
	}
}